import React from "react";
import Layout from "./src/components/layout/Layout";

export const wrapPageElement = ({ element, props }) => (
	<Layout pathname={props.location.pathname}>
		{element}
	</Layout>
);